import { render, staticRenderFns } from "./screening-content.vue?vue&type=template&id=f572e530&scoped=true"
import script from "./screening-content.vue?vue&type=script&lang=js"
export * from "./screening-content.vue?vue&type=script&lang=js"
import style0 from "./screening-content.vue?vue&type=style&index=0&id=f572e530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f572e530",
  null
  
)

export default component.exports